var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_197_5915",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.100098,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_197_5915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10007 18.9999H9.44625V13.9614C9.44625 13.7053 9.53286 13.4907 9.7061 13.3174C9.87933 13.1442 10.094 13.0576 10.3501 13.0576H13.85C14.1061 13.0576 14.3208 13.1442 14.494 13.3174C14.6673 13.4907 14.7539 13.7053 14.7539 13.9614V18.9999H18.1001V10.1537C18.1001 10.1025 18.0889 10.056 18.0664 10.0143C18.044 9.97265 18.0135 9.93579 17.9751 9.90374L12.2828 5.62489C12.2315 5.58002 12.1706 5.55759 12.1001 5.55759C12.0296 5.55759 11.9687 5.58002 11.9174 5.62489L6.22507 9.90374C6.18662 9.93579 6.15617 9.97265 6.13372 10.0143C6.11129 10.056 6.10007 10.1025 6.10007 10.1537V18.9999ZM4.6001 18.9999V10.1537C4.6001 9.86752 4.66412 9.59638 4.79217 9.34029C4.92022 9.08421 5.09722 8.87332 5.32317 8.70762L11.0155 4.41917C11.3314 4.17813 11.6924 4.05762 12.0985 4.05762C12.5047 4.05762 12.8667 4.17813 13.1847 4.41917L18.877 8.70762C19.1029 8.87332 19.2799 9.08421 19.408 9.34029C19.536 9.59638 19.6 9.86752 19.6 10.1537V18.9999C19.6 19.4089 19.4523 19.7611 19.1568 20.0566C18.8613 20.3521 18.509 20.4999 18.1001 20.4999H14.1578C13.9017 20.4999 13.687 20.4132 13.5138 20.24C13.3405 20.0668 13.2539 19.8521 13.2539 19.596V14.5575H10.9462V19.596C10.9462 19.8521 10.8596 20.0668 10.6864 20.24C10.5131 20.4132 10.2985 20.4999 10.0424 20.4999H6.10007C5.69111 20.4999 5.33887 20.3521 5.04337 20.0566C4.74786 19.7611 4.6001 19.4089 4.6001 18.9999Z",
    fill: "#BABABA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGrey);
export default __webpack_public_path__ + "static/media/home_grey.53eeb776ba37046c2b4034249f10086e.svg";
export { ForwardRef as ReactComponent };